/**
 * Product `image` from API is usually `/uploads/...`. While editing, the form may hold a `data:` URL before save.
 */
// API Configuration
const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || "http://localhost:3001";

export function getDashboardProductImageSrc(image: string | null | undefined): string | undefined {
	if (image == null || String(image).trim() === "") return undefined;
	const img = String(image).trim();
	if (img.startsWith("data:") || img.startsWith("blob:") || img.startsWith("http://") || img.startsWith("https://")) {
		return img;
	}

	const host = PUBLIC_URL;

	const base = (host ?? "").replace(/\/$/, "");
	const path = img.replace(/^\/+/, "");
	if (!base) return `/${path}`;
	return `${base}/${path}`;
}
